import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-checkmark',
  imports: [],
  templateUrl: './checkmark.component.html',
  styleUrls: ['./checkmark.component.scss'],
  animations: [
    trigger('successAnimation', [
      state('hidden', style({ opacity: 0, transform: 'scale(0)' })),
      state('visible', style({ opacity: 1, transform: 'scale(1)' })),
      transition('hidden => visible', [animate('0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)')]),
    ]),
  ],
})
export class CheckmarkComponent implements OnInit {
  animationState = 'hidden';

  ngOnInit() {
    this.animationState = 'visible';
  }
}
